import React from 'react';
import PropTypes from 'prop-types';
import { getPlanModalProps } from '../../../../lib/plans'
import { LIMITED_ACCESS_ROLES } from '../../../../lib/constants';
import Switch from 'react-switch';
import ghAnalytics from '../../../../lib/analytics';
import LayerLegends from './LayerLegends'
import UserPlanModal from '../../../Modals/UserPlanModal';
import styles from './LayerListItem.module.scss';

export default function LayerListItem(props) {
  const userPlanModal = (props) => {
    const userPlan = getPlanModalProps(props)
    setTimeout(() => {
      props.dispatch({
        type: 'modals/add',
        payload: {
          props: userPlan,
          component: UserPlanModal
        }
      });
    }, 250)
  };

  const toggleLayerEnabled = (newState) => {
    const role = props.userProfile.roles[0];
    if (LIMITED_ACCESS_ROLES.includes(role)) {
      userPlanModal(props);
    } else {
      if (newState) {
        ghAnalytics.logLayerEnabled(props.stateName, props.categoryName, props.subCategoryName, props.layer.layerName.trim());
      }
      else {
        ghAnalytics.logLayerDisabled(props.stateName, props.categoryName, props.subCategoryName, props.layer.layerName.trim());
      }

      props.dispatch({
        type: 'layers/setLayerEnabledStatus',
        payload: {
          categoryName: props.categoryName,
          layerName: props.layer.layerName,
          stateName: props.stateName,
          status: newState,
          subCategoryName: props.subCategoryName,
        }
      });
    }
  };

  return (
    <>
      <div
        className={styles.layerListItem}
        onClick={() => toggleLayerEnabled(!(props.layer.control.enabled != null ? props.layer.control.enabled == 1 : false))}
      >
        <div className={styles.layerName}>
          {props.layer.layerName}
        </div>
        <span onClick={e => e.stopPropagation()}>
          <Switch
            checked={props.layer.control.enabled != null ? props.layer.control.enabled == 1 : false}
            onChange={toggleLayerEnabled}
            checkedIcon={false}
            uncheckedIcon={false}
            onColor='#119955'
            offColor='#505050'
            onHandleColor='#ffffff'
            offHandleColor='#ffffff'
            height={16}
            width={32}
            handleDiameter={12}
          />
        </span>
      </div>
      <LayerLegends layer={props.layer} />
    </>
  );
}

LayerListItem.propTypes = {
  categoryName: PropTypes.string,
  layer: PropTypes.object,
  stateName: PropTypes.string,
  statesLayers: PropTypes.array,
  subCategoryName: PropTypes.string,
  userProfile: PropTypes.object,
};

LayerListItem.defaultProps = {
  subCategoryName: null
};